<template>
  <div class="bg-white border p-2 mt-3">
    <div class="table-responsive position-relative"
      :class="{ 'with-actions-gap': changeLogs.length < 4, 'opacity-50': loading }">
      <table class="table">
        <caption class="sr-only" data-no-export>{{ i18n('Registry of changes') }}</caption>
        <thead>
          <tr class="d-none d-lg-table-row">
            <th class="text-nowrap" scope="col">{{ i18n('Objective user') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('User making the change') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Date') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Field/Application') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('Old value') }}</th>
            <th class="text-nowrap" scope="col">{{ i18n('New value') }}</th>
            <th data-no-export scope="col" style="min-width: 48px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <AuditChangeListItem v-for="changeLog in changeLogs" :changeLog="changeLog" :key="changeLog.id"
            @deleted="$emit('deleted', $event)" @updated="$emit('updated', $event)"
            @updating="$emit('updating', $event)" />
          <EmptyListItem v-if="!changeLogs || changeLogs.length == 0" :loading="loading" :colspan="5" />
          <LazyLoadListItem v-if="!loading && (lazyLoad || autoLazyLoad)"
            :autoLazyLoad="!pagination.singlePage && autoLazyLoad" :colspan="5" @next="$emit('next', $event)" />
        </tbody>
      </table>
      <div class="position-absolute h-100 w-100 top-0" @click.stop v-if="loading"></div>
    </div>
    <Pagination cssClass="mt-2" v-if="pagination && pagination.singlePage && pagination.limit < pagination.total"
      :pagination="pagination" :loading="loading" @goToPage="(...args) => $emit('goToPage', ...args)" />
  </div>
</template>

<script>
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import LazyLoadListItem from "@/components/common/list/LazyLoadListItem.vue";
import Pagination from "@/components/common/list/Pagination.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";
import AuditChangeListItem from "@/components/auditChange/AuditChangeListItem.vue";

export default {
  components: {
    EmptyListItem,
    LazyLoadListItem,
    Pagination,
    Tooltip,
    AuditChangeListItem,
  },
  emits: [
    'updated',
    'deleted',
    'updated',
    'updating',
    'next',
    'goToPage',
  ],
  props: {
    loading: Boolean,
    lazyLoad: Boolean,
    autoLazyLoad: Boolean,
    pagination: Object,
    changeLogs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
  },
};
</script>